import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';

import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';

import Snackbar from '../../../labels/Snackbar';
import BlueButton from '../../../buttons/BlueButton';

class MenuValue extends React.Component {
    state = {
        report_appcc: undefined,
        value: '',
        from: '',
    };


    constructor(props) {
        super(props);
        if (!this.props.result) {
            this.props.loadAPPCC(undefined, undefined).catch((error) => { });
        }
    }

    static getDerivedStateFromProps(props, state) {
        const { report_appcc, info } = props;
        if (report_appcc !== state.report_appcc || info !== state.info) {
            state.report_appcc = report_appcc;
            state.local = report_appcc ? report_appcc.local : undefined;
            state.from = report_appcc && report_appcc.from ? report_appcc.from : '';
            state.info = info;
            state.nodes =
                info && info.security && info.security.locals && info.security.locals.length > 0
                    ? info.security.locals.reduce((arr, c) => {
                        if (
                            info.security.localPermits[c.id] &&
                            info.security.localPermits[c.id].length > 0
                        ) {
                            arr.push(c);
                        }
                        return arr;
                    }, [])
                    : [];
            return state;
        }
        return null;
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    };

    handleSearch = (event) => {
        const { local, from } = this.state;
        if (local && from) {
            this.props
                .loadAPPCC(local, from)
                .then(() => this.props.history.push('/reports/appcc/result'))
                .catch((error) => {
                    this.setState({ error: error.message, errorType: error.type });
                });
        }
    };

    handleChange = (event) => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleCloseError = () => {
        this.setState({ error: '' });
    };

    render() {
        const { local, from, nodes, error, errorType } = this.state;
        const { intl } = this.props;
        return (
            <div className={'flex_full_column padding_bottom_9 height100 center'}>
                <div className="width50 padding_borders_flat">
                    <div className="flex_full_row align_center margin_bottom_12">
                        <FormControl className={'flex_full width100 barlow_italic c_slate'}>
                            <InputLabel htmlFor="age-native-simple">
                                {intl.formatMessage({ id: 'type_label_local' })}
                            </InputLabel>
                            <Select
                                native
                                value={local}
                                onChange={this.handleChange}
                                inputProps={{ name: 'local', id: 'local-id' }}
                            >
                                <option key={randomstring()} value={undefined} />
                                {nodes &&
                                    nodes
                                        .sort((a, b) => (a.nombre < b.nombre ? -1 : 1))
                                        .map((cat) => {
                                            return (
                                                <option key={randomstring()} value={cat.id}>
                                                    {cat.name}
                                                </option>
                                            );
                                        })}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="flex_full_row align_center margin_bottom_12">
                        <TextField
                            fullWidth
                            name={'from'}
                            id={'from-date'}
                            label={intl.formatMessage({ id: 'date' })}
                            type="date"
                            value={from}
                            onChange={this.handleChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </div>

                    <BlueButton noValid={!local || !from} id="search" onClick={this.handleSearch} />
                </div>
                {error && (
                    <Snackbar
                        open={true}
                        variant={errorType ?  errorType : "error"}
                        text={error}
                        onClose={this.handleCloseError.bind(this)}
                    />
                )}
            </div>
        );
    }
}

MenuValue.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(MenuValue);



// WEBPACK FOOTER //
// ./src/components/complex/reports/appcc/Menu.js